export * from './lib/contact-birthday/contact-birthday.component';
